import {Component, Input, ViewChild} from '@angular/core';
import {ConnectInterfacesService} from 'app/connect/core/connect-interfaces.service';
import {NgForm} from '@angular/forms';
import { IAdvancedWebServiceMetadata } from 'app/connect/core/IConnectInterfacesMetadata';
import { IConnectInterface } from 'app/connect/core/IConnectInterface';
import { ISecurityOption } from 'app/connect/core/ISecurityOption';
import { ISecurityType } from 'app/connect/core/ISecurityType';

@Component({
    selector: 'connect-interfaces-adv',
    templateUrl: 'connect-interfaces-adv.component.html',
    styleUrls: ['connect-interfaces-adv.component.scss']
})
export class ConnectInterfacesAdvComponent {

    public securityTypes: ISecurityType[];
    public username: string;
    public password: string;
    public selectedSecurityType: ISecurityType;
    public editModeSecurityOption: ISecurityOption;
    @Input() selectedInterface: IConnectInterface;
    @Input() metadata: IAdvancedWebServiceMetadata;
    @ViewChild('addSecurityOptionsForm', { static: false}) addSecurityOptionsForm: NgForm;

    constructor(private _connectInterfacesService: ConnectInterfacesService) { }

    ngOnInit() {
        this.securityTypes = this._connectInterfacesService.getSecurityTypes();
    }

    addSecurityOption() {
        if (this.selectedSecurityType && this.username && this.password) {
            if (!this.selectedInterface.environment.messagesecurity) {
                this.selectedInterface.environment.messagesecurity = [];
            }
            this.selectedInterface.environment.messagesecurity.push(
              { type: this.selectedSecurityType.name,
                username: this.username, password: this.password }
              );
            this.clearFieldsSecurityOptions();
        }
    }

    changeSelectedSecurityType(value) {
        this.selectedSecurityType = value;
    }

    editSecurityOption(securityOption: ISecurityOption) {
        this.editModeSecurityOption = securityOption;
        console.log(this.selectedInterface.environment.messagesecurity);
    }

    removeSecurityOption(securityOption: ISecurityOption) {
        _.remove(this.selectedInterface.environment.messagesecurity, securityOption);
    }

    clearFieldsSecurityOptions() {
        this.addSecurityOptionsForm.reset();
    }

    saveEditSecurityOption(securityOption: ISecurityOption) {
        this.editModeSecurityOption = null;
    }

}
